import script from "./PandoraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraModal.vue?vue&type=script&setup=true&lang=js"

import "./PandoraModal.vue?vue&type=style&index=0&id=62d8a30c&lang=css"

const __exports__ = script;

export default __exports__